import { comparerByAlphabet } from '@app/comparers';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Brief } from '@app/models';
import {
  // ColorActionsUnion,
  // BriefActionTypes,
  BriefActionTypes,
  BriefActionsUnion
} from '@core/actions/brief.actions';

export interface State extends EntityState<Brief> {
  loading: boolean;
  loaded: boolean;
  briefs: any[];
  spinnerMessage: string;
  infoModal: any
  // creating: boolean;
}

export const adapter: EntityAdapter<Brief> = createEntityAdapter<Brief>({
  selectId: (brief: Brief) => brief.id,
  sortComparer: comparerByAlphabet('ASC', 'name')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  spinnerMessage: null,
  briefs: [],
  infoModal: {}
});

export function reducer(
  state: State = INITIAL_STATE,
  action: BriefActionsUnion
) {
  switch (action.type) {
    case BriefActionTypes.CreateBrief:
    case BriefActionTypes.ExportBrief:
    case BriefActionTypes.UpdateBrief:
    case BriefActionTypes.ChangeStatus:
    case BriefActionTypes.GetLink:
    case BriefActionTypes.Load:
      return { ...state, loading: true };
      
    case BriefActionTypes.UpdateBriefFail:
    case BriefActionTypes.ExportBriefSuccess:
    case BriefActionTypes.ExportBriefFail:
    case BriefActionTypes.LoadFail:
      return { ...state, loading: false };

    case BriefActionTypes.UpdateBriefSuccess:
    case BriefActionTypes.ChangeStatusSuccess:
      return {
        ...state,
        loading: false,
        briefs: [
          ...state.briefs.filter((x) => x.id !== action.data.id),
          action.data
        ]
      }

    case BriefActionTypes.CreateBriefSuccess:
      console.log("ADAPTER REDUCER CREACION BRIEF ->", action.data)
      return {
        ...state,
        loading: false,
        briefs: [
          ...state.briefs,
          action.data
        ]
      }

    case BriefActionTypes.LoadSuccess:
      return adapter.addAll(action.data, {
        ...state,
        loading: false,
        briefs: action.data
      });
    case BriefActionTypes.LoadInfoModalSuccess:
      console.log("DATA REDUCER INFO MODAL", action.data)
      return {
        ...state,
        infoModal: action.data
      }

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;

export const getState = createFeatureSelector<State>('briefs');

export const getSpinnerMessage = createSelector(
  getState,
  (state: State) => state.spinnerMessage
);

export const getBriefs = createSelector(
  getState,
  (state: State) => state.briefs
);

export const getInfoModal = createSelector(
  getState,
  (state: State) => state.infoModal
)

export const getIsLoading = createSelector(
  getState,
  selectLoading
)